import React, { FC, PropsWithChildren } from 'react';
import { ToastContainer } from 'react-toastify';
import { ErrorBoundary } from 'components/common/ErrorBoundary';
import { Header } from './Header';
import { Footer } from './Footer';
import { HelpCenter } from './HelpCenter';
import { SplashScreen } from './SplashScreen';
import { SgwtConnect } from './SgwtConnect';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
    return (
        <div>
            <Header />
            <main className="bg-lvl1 py-4" style={{ minHeight: 'calc(100vh - var(--header-height))' }}>
                <ErrorBoundary>{children}</ErrorBoundary>
            </main>
            <Footer />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeButton={false}
                icon={false}
                newestOnTop
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
                stacked
            />
            <HelpCenter />
            <SgwtConnect />
            <SplashScreen />
        </div >);
};
